module.exports = __webpack_public_path__ + "files/df45c7958012996d251a01b4183a2882.woff2";


//////////////////
// WEBPACK FOOTER
// ./non_npm_dependencies/google-fonts/fonts/sourcesanspro-bolditalic-webfont.woff2
// module id = 777
// module chunks = 60